import React from "react"

const IconRecovered = () => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width="24"
         height="24"
         viewBox="0 0 24 24"
      >
         <path d="M7 6V4a2 2 0 012-2h6a2 2 0 012 2v2h5a2 2 0 012 2v12a2 2 0 01-2 2H2a2 2 0 01-2-2V8a2 2 0 012-2h5zm6 7v-3h-2v3H8v2h3v3h2v-3h3v-2h-3zm1.5-9h-5a.5.5 0 00-.5.5V6h6V4.5a.5.5 0 00-.5-.5"></path>
      </svg>
   )
}

export { IconRecovered as default }
